import { inject, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import {
  CacheService,
  provideResourceRegistrations,
} from '@bindoc-projects/resource-lib/data';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { UserFileService } from './user-file.service';

export function provideUserFileData(): Provider[] {
  return [
    {
      provide: UserFileService,
      useFactory: () =>
        new UserFileService(
          { API_TOKENS: { BASE: ApiEndpointKey.BD_FILES_RESOURCE_URL } },
          inject(BdAppEnvironmentService),
          inject(CacheService),
          inject(HttpClient),
        ),
    },
    ...provideResourceRegistrations(UserFileService, ShareableType.FILE),
  ];
}
